import styled from 'styled-components';
import { white } from 'styles/Colors';

interface IPitchResultContainerProps {
  visible: boolean;
}

export const Background = styled.div`
  width: 1110px;
  height: 351px;
  position: relative;
`;

export const PitchResultContainer = styled.div<IPitchResultContainerProps>`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  ${(props): string => (!props.visible ? 'visibility: hidden;' : '')}
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Icon = styled.div`
  margin-bottom: 6px;
`;

export const HeaderLabel = styled.label`
  color: ${white};
  text-align: center;
  font-family: Lato;
  font-size: 25px;
  font-style: normal;
  font-weight: 700;
  line-height: 35px;
`;

export const InfoList = styled.ul`
  color: ${white};
  font-family: Lato;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
`;

export const Description = styled.div`
  color: ${white};
  font-family: Lato;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
`;
